module.exports = __webpack_public_path__ + "static/initiator-a22da7ea6dbebba52de951f9f35824fd.png";